<template>
  <svg aria-hidden="true" viewBox="0 0 1200 1200" ...attributes>
    <path
      fill="#1B2D3C"
      d="M854.8 400.1c-5.2-111.2-97.3-200.1-209.8-200.1-107.8 0-196.8 81.6-208.6 186.3-22.2-10.6-46.6-16.3-71.4-16.3-91 0-165 74-165 165s74 165 165 165h75v-40h-75c-68.9 0-125-56.1-125-125s56.1-125 125-125c28.6 0 55.6 9.4 77.9 27.2l.2-.3c3.3 2.5 7.4 3.9 11.9 3.9 11 0 20-9 20-20v-.5h.4c-.2-3.7-.3-7.1-.3-10.4 0-93.7 76.3-170 170-170s170 76.3 170 170c0 3.1-.1 6.4-.3 9.8l-.1 1.1c0 11 9 20 20 20 .8 0 2.3-.1 2.3-.1 4.3-.5 8.7-.8 13-.8 60.7 0 110 49.3 110 110s-49.3 110-110 110h-90v40h90c82.7 0 150-67.3 150-150 0-81-64.7-147.3-145.2-149.8z"
    ></path>
    <path
      fill="#63CC98"
      d="M848 520c-12.4 0-23 7.5-27.6 18.2l-140.4 47.4v494.4c0 11 9 20 20 20s20-9 20-20v-465.6l113.2-38.2c4.4 2.5 9.4 3.9 14.8 3.9 16.6 0 30-13.4 30-30s-13.4-30.1-30-30.1z"
    ></path>
    <path
      fill="#7DB9D8"
      d="M600 370.9c-16.6 0-30 13.4-30 30 0 9.1 4.1 17.3 10.5 22.8v656.3c0 11 9 20 20 20s20-9 20-20v-657.2c5.8-5.5 9.5-13.3 9.5-21.9 0-16.6-13.4-30-30-30zm-235 134.1c-16.6 0-30 13.4-30 30s13.4 30 30 30c4.1 0 7.9-.8 11.5-2.3l103.5 49.9v467.4c0 11 9 20 20 20s20-9 20-20v-492.6l-126.2-60.8c-3.6-12.4-15.1-21.6-28.8-21.6z"
    ></path>
  </svg>
</template>
